/* eslint-disable jsx-a11y/label-has-associated-control */
//import { Link } from '@mui/material';

import { Form, Table } from 'semantic-ui-react';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';

const Downloadcentermodal = ({
  t,
  recordID,
  title,
  setTitle,
  titleEn,
  setTitleEn,
  showPreview,
  onUpdate,
  onChange,
  setGridModalupdate,
  gridModalupdate,
  handleFileDelete,
  inputFile,
  doc,
  FileInputRef,
}) => {
  return (
    <>
      {gridModalupdate ? (
        <>
          {/* <div
            className={`flex justify-center items-center overflow-x-hidden h-full w-full ${isActive ? 'top-0 right-0  ' : 'top-0 left-0 '} opacity-100 fixed inset-40 z-50 bg-black bg-opacity-50 outline-none focus:outline-none`}
          >
            <div className="border-0 rounded-lg shadow-lg bg-green-50 flex-col pt-20 outline-none focus:outline-none relative   w-4/5 flex justify-center max-h-[450px] overflow-y-auto p-5 z-50 my-6 mx-auto max-w-3xl">
              <div className="flex justify-center rounded-t ">
                <h3 className="text-xl pt-20 justify-center text-center text-customgreen font-semibold">
                  {t('update')} {t('Download Center')}
                </h3>
              </div>
              <div className="relative p-6 flex-auto">
                <form className=" rounded px-8 pt-6 pb-8 w-full">
                  <div className="row justify-center">
                    <div className="col-lg-6 flex flex-col items-start justify-start">
                      <label className="block text-customgreen text-sm font-bold my-2">{t('cms_title')}</label>
                      <input
                        className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                        type="text"
                        name="title"
                        value={title}
                        required
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder={t('cms_title')}
                      />
                    </div>
                    <div className="col-lg-6 flex flex-col items-start justify-start">
                      <label className="block text-customgreen text-sm font-bold my-2">{t('Content En')}</label>
                      <input
                        className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                        type="text"
                        name="title_En"
                        value={titleEn}
                        required
                        onChange={(e) => setTitleEn(e.target.value)}
                        placeholder={t('Content En')}
                      />
                    </div>
                  </div>
                  <label className="block text-customgreen text-sm font-bold my-2">
                    {t('Documents upload')} <span className="text-red-700 ">{t('(Upload PDF File)')}</span>
                  </label>
                  <input
                    className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                    name="link"
                    type="file"
                    accept=".pdf"
                    onChange={(showPreview, onChange)}
                    id="image-uploader"
                  />

                </form>
              </div>
              <div className="flex items-center justify-center space-x-2 p-6 border-t border-solid border-blueGray-200 rounded-b">
                <button
                  className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center "
                  type="button"
                  onClick={() => onUpdate(data.downloadCenterID)}
                >
                  {t('Submit')}
                </button>
                <button
                  className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center "
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  {t('Close')}
                </button>
              </div>
            </div>
          </div> */}
          <MDBModal tabIndex="-1" show={gridModalupdate} setShow={setGridModalupdate}>
            <MDBModalDialog className="flex justify-center items-center">
              <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                  <MDBModalHeader>
                    <MDBModalTitle className="text-customgreen font-semibold">
                      {t('update')} {t('Download Center')}
                    </MDBModalTitle>
                    {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                  </MDBModalHeader>
                  <MDBModalBody>
                    <div className="container-fluid bd-example-row">
                      <div className="row" style={{ marginBottom: '10px' }}>
                        <div className="col-md-6 col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('cms_title')} : </label>
                            <input
                              className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              type="text"
                              name="title"
                              value={title}
                              required
                              onChange={(e) => setTitle(e.target.value)}
                              placeholder={t('cms_title')}
                            />
                          </Form.Field>
                        </div>
                        <div className="col-md-6 col-example">
                          <Form.Field>
                            <label className="mx-auto text-customgreen">{t('Title En')} : </label>
                            <input
                              className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              type="text"
                              value={titleEn}
                              name="title_En"
                              required
                              onChange={(e) => setTitleEn(e.target.value)}
                              placeholder={t('Title En')}
                            />
                          </Form.Field>
                        </div>
                      </div>

                      <div className="row" style={{ marginBottom: '10px' }}>
                        <div className="col-md-12 col-example">
                          <Form.Field>
                            <label className="mx-auto  text-customgreen">
                              {t('Documents upload')} <span className="text-red-700 ">{t('(Upload PDF File)')}</span>
                            </label>
                            <input
                              className="mb-3  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              onChange={(showPreview, onChange)}
                              type="file"
                              accept=".pdf"
                              ref={FileInputRef}
                            />
                          </Form.Field>

                          <div className="row mt-3">
                            <div className="col-lg-12  overflow-x-auto">
                              <Table className="text-sm text-left rtl:text-right ">
                                <Table.Header className="text-xs text-white bg-customgreen uppercase  ">
                                  <Table.Row>
                                    <Table.Cell className="text-white">{t('sNo')}</Table.Cell>
                                    <Table.Cell className="text-white">{t('File')}</Table.Cell>
                                    <Table.Cell className="text-white">{t('Action')}</Table.Cell>
                                  </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                  <Table.Row>
                                    <Table.Cell>1</Table.Cell>
                                    <Table.Cell>
                                      {/* {!allowedFileExtensions.includes(FileCheck) ||
                                        inputFileSize > 1097152 ? (
                                          <label
                                            style={{
                                              color: 'red',
                                              fontWeight: '500'
                                            }}>
                                            Uploaded File must contain these formats [jpg, png,
                                            jpeg, pdf]and must not be greater than 2 MBs.
                                            {inputFileSize} -- {FileCheck}
                                          </label>
                                        ) : ( */}
                                      <label>{inputFile}</label>
                                      {/* )} */}
                                    </Table.Cell>
                                    <Table.Cell>
                                      <button
                                        className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                        onClick={() => {
                                          const link = document.createElement('a');

                                          link.href = `data:application/pdf;base64,${doc}`;
                                          link.download = inputFile;

                                          document.body.appendChild(link);
                                          link.click();

                                          document.body.removeChild(link);
                                        }}
                                        style={{ margin: '5px' }}
                                      >
                                        <FileDownloadOutlinedIcon />
                                      </button>
                                      <button
                                        className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                        style={{
                                          margin: '5px',
                                        }}
                                        onClick={(e) => handleFileDelete(e)}
                                      >
                                        {t('Delete')}
                                        {/* <DeleteOutlinedIcon /> */}
                                      </button>
                                    </Table.Cell>
                                  </Table.Row>
                                </Table.Body>
                              </Table>
                            </div>
                          </div>

                          {/* <img style={{ height: '120px', width: '150px' }} src={values.imageSrc} className="card-img-top" /> */}
                        </div>
                      </div>
                    </div>
                  </MDBModalBody>
                  <MDBModalFooter className="flex justify-center">
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
                      onClick={() => onUpdate(recordID)}
                    >
                      {t('Submit')}
                    </button>
                    <button
                      className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      onClick={() => setGridModalupdate(false)}
                      type="button"
                    >
                      {t('close')}
                    </button>
                  </MDBModalFooter>
                </Form>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        </>
      ) : null}
    </>
  );
};

export default Downloadcentermodal;
